module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <span class="salesforce-commerce-label">\n        <input type="text" class="productID full-width" placeholder="Product / item ID here">\n    </span>\n    <span class="help-block">\n        Preview the QuickView at your website via the Drag\'n Drop Publishing Feature.\n    </span>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewActionPropertiesView.tpl
// module id = 1708
// module chunks = 0